import { render, staticRenderFns } from "./MediosPopupComponent.vue?vue&type=template&id=2a722a31&"
import script from "./MediosPopupComponent.vue?vue&type=script&lang=js&"
export * from "./MediosPopupComponent.vue?vue&type=script&lang=js&"
import style0 from "./MediosPopupComponent.vue?vue&type=style&index=0&id=2a722a31&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports